import { createApi } from '@reduxjs/toolkit/query/react';
import ssoBaseQuery from '@/services/ssobase.query';
import { LoginResponse } from '@/services/api.types';

// `activateAuthToken` (POST /v1/oiosaml3/sso) was removed by ADR-7 as a dead
// definition: nothing consumed it, because SSO initiation is a real form POST that
// the browser must follow through the IdP redirect chain, not an XHR
// (login.tsx handleSSORedirect). It also exported a hook name —
// useActivateAuthTokenMutation — that auth.api.ts exported a SECOND copy of, so
// whichever one an autocomplete offered was a coin flip; both are gone now.
const ssoApi = createApi({
  reducerPath: 'ssoApi',
  baseQuery: ssoBaseQuery,
  endpoints: builder => ({
    // Exchange the IdP-callback totp for the login result. Returns `LoginResponse`,
    // i.e. `oneof {completed, pending}` — ufs's TotpReply is now ISOMORPHIC to
    // naestved's LoginResp (contract §4.5), not "a token plus an extra field".
    //
    // This is an intentional, FE-visible breaking change (batch 004, ADR-9): SSO
    // logins have to pass the ToS/PP gate too, so the reply must be able to say
    // "held at consent" rather than only "here is your token". Isomorphism is what
    // lets login.tsx hand the response straight to advanceLoginStep instead of
    // hand-wrapping it — the shapes are literally the same now.
    activateTotp: builder.mutation<LoginResponse, string>({
      query: totp => ({
        url: '/api/v1/oiosaml3/totp',
        method: 'POST',
        body: { totp },
      }),
    }),
  }),
});

export const { useActivateTotpMutation } = ssoApi;
export default ssoApi;
